import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getCodeFor } from "@/lib/publicSettings";

// Injects admin-managed raw HTML/script into <head> and <body> per route.
// Managed containers are tagged so they can be cleaned up on navigation.
const ATTR = "data-managed-code";

function inject(parent, html, position) {
  if (!html) return;
  const holder = document.createElement("div");
  holder.setAttribute(ATTR, "1");
  // Re-create <script> nodes so they execute (innerHTML scripts don't run).
  const tpl = document.createElement("template");
  tpl.innerHTML = html;
  tpl.content.querySelectorAll("script").forEach((old) => {
    const s = document.createElement("script");
    [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
    s.textContent = old.textContent;
    old.replaceWith(s);
  });
  holder.appendChild(tpl.content);
  if (position === "start") parent.prepend(holder);
  else parent.appendChild(holder);
}

export default function useCodeInjection() {
  const { pathname } = useLocation();

  useEffect(() => {
    let alive = true;
    (async () => {
      const code = await getCodeFor(pathname);
      if (!alive) return;
      document.querySelectorAll(`[${ATTR}]`).forEach((n) => n.remove());
      inject(document.head, code.headStart, "start");
      inject(document.head, code.headEnd, "end");
      inject(document.body, code.bodyStart, "start");
      inject(document.body, code.bodyEnd, "end");
    })();
    return () => {
      alive = false;
    };
  }, [pathname]);
}
